import gsap from 'gsap';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';

class ScrollItem__Footer extends VScroll_Item {
  _fakeFooter;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._fakeFooter = GetBy.id('FakeFooter');

    this.onShow = () => {
      this.onMove();
    };
    this.onHide = () => { };
    this.onMove = () => {
      const blur = Maths.clamp(Maths.map(this.progressInside, 0, -.3, 0, 5), 0, 5);
      const opa = Maths.clamp(Maths.map(this.progressInside, 0, -.3, .6, .2), .2, .6);

      gsap.set(this._fakeFooter, { opacity: opa, filter: `blur(${blur}px)` });
    };
  }
}

Scroll._registerClass('Footer', ScrollItem__Footer);
